/**
 * 電話番号を右から4桁ごとにハイフン区切りでフォーマットする。
 * 先頭の国番号 81（日本）/ 84（ベトナム）は 0 に置換する。
 * 例: "09012345678" → "090-1234-5678"
 */
export const formatPhoneNumber = (numberVal: string | number): string => {
  let digits = String(numberVal)

  // 国番号 → 国内プレフィックスに変換
  if (digits.startsWith('81')) digits = '0' + digits.slice(2)
  else if (digits.startsWith('84')) digits = '0' + digits.slice(2)

  // 右から4桁ごとにハイフンを挿入
  const chunks: string[] = []
  for (let i = digits.length; i > 0; i -= 4) {
    chunks.unshift(digits.slice(Math.max(0, i - 4), i))
  }
  return chunks.join('-')
}
